var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargingUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\r\n\t\t.st0{clip-path:url(#SVGID_00000000186012699294912830000008677071498788816053_);fill:url(#SVGID_00000032624637648780479900000007795316780496576646_);}\r\n\t.st1{fill:url(#SVGID_00000150787563125620055170000008849386853952081593_);}\r\n\t.st2{fill:url(#SVGID_00000100350985327227939380000001333853470049283751_);}\r\n\t.st3{fill:url(#SVGID_00000093858969658889636750000005495964005708030109_);}\r\n\t.st4{fill:url(#SVGID_00000036243822449313808680000000925715840303564710_);}\r\n\t.st5{fill:url(#SVGID_00000148654633737146898400000009530083901741450413_);}\r\n\t.st6{fill:url(#SVGID_00000174565352312302668180000012441017582120957841_);}\r\n\t.st7{fill:url(#SVGID_00000088849434080167257190000017843158712611135382_);}\r\n\t.st8{fill:url(#SVGID_00000036242063247756625430000018130377497822409654_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096039195545651991140000007267875358614976394_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.5,
    y1: 32.0213,
    x2: 17.5,
    y2: 2.9787
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02FEF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02D2CA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096039195545651991140000007267875358614976394_)"
    },
    d: "M12.5,32c-0.4-0.2-0.5-0.4-0.5-0.8 c0-4.8,0-9.7,0-14.5c0-0.1,0-0.2,0-0.4c-0.1,0-0.2,0-0.3,0c-2,0-4,0-6.1,0c-0.1,0-0.3,0-0.4,0c-0.4-0.1-0.6-0.5-0.3-0.9 c0.1-0.1,0.2-0.2,0.2-0.3C9.1,11.2,13,7.2,16.9,3.3c0.5-0.5,0.7-0.5,1.2,0c3.9,3.9,7.8,7.8,11.7,11.8c0.1,0.1,0.2,0.2,0.2,0.3 c0.2,0.3,0.1,0.8-0.3,0.9c-0.1,0-0.3,0-0.4,0c-2,0-4,0-6.1,0c-0.1,0-0.2,0-0.4,0c0,0.1,0,0.3,0,0.4c0,4.8,0,9.7,0,14.5 c0,0.4-0.1,0.7-0.4,0.9C19.2,32,15.8,32,12.5,32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingUp);
export default __webpack_public_path__ + "static/media/charging_up.9c2df3e7984efeb5113db703c9a16d09.svg";
export { ForwardRef as ReactComponent };